import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllOfferResponse,
  getOfferByIdResponse,
  getActiveOffersResponse,
} from "../actions";

export function* createOfferEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`offer`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Offer added successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllOfferEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`offer/all`));
    yield put(getAllOfferResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllOfferResponse([]));
  }
}

export function* getOfferByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`offer/1`));
    yield put(getOfferByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getOfferByIdResponse([]));
  }
}

export function* updateOfferEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`offer/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Offer edited successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* deleteOfferEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`offer/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Offer deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getActiveOffersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`offer/active`));
    yield put(getActiveOffersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getActiveOffersResponse([]));
  }
}

export function* offerWatcherSaga() {
  yield takeLatest(types.CREATE_OFFER, createOfferEffectSaga);
  yield takeLatest(types.GET_ALL_OFFER, getAllOfferEffectSaga);
  yield takeLatest(types.GET_OFFER, getOfferByIdEffectSaga);
  yield takeLatest(types.UPDATE_OFFER, updateOfferEffectSaga);
  yield takeLatest(types.DELETE_OFFER, deleteOfferEffectSaga);
  yield takeLatest(types.GET_OFFER, getActiveOffersEffectSaga);
}
